export const MOTIVATION_P1A_FACT_CODES = [
  'MATCHES_PLAYED',
  'MATCHES_WON',
  'GAMES_WON',
  'GAME_SHARE',
  'GAME_SHARE_VS_OWN_TRAILING_MEAN',
  'CLOSE_SET_RECORD',
  'TIEBREAK_RECORD',
  'COMEBACK_COUNT',
  'PERSONAL_BEST_GAME_SHARE_VS_OPPONENT',
] as const;

export type MotivationFactCode = typeof MOTIVATION_P1A_FACT_CODES[number];
export type MotivationDiscipline = 'SINGLES' | 'DOUBLES';
export type MotivationEvidenceScope = 'VERIFIED_ONLY' | 'CASUAL_ONLY' | 'COMBINED_LABELED';
export type MotivationValueKind = 'COUNT' | 'TIERED_COUNT' | 'RATIO' | 'RECORD' | 'TREND' | 'BEST';

export type MotivationFactValue =
  | { count: number; unit: string }
  | { verifiedCount: number; casualCount: number; unit: string }
  | { value: number }
  | { wins: number; losses: number; ties: number; matches: number }
  | { current: number; baseline: number; delta: number; baselineSampleCount: number }
  | { value: number; achievedPeriod: string; counterparty: { label: string; participants: [] } };

export interface MotivationFact {
  factCode: MotivationFactCode;
  title: string;
  facet: {
    discipline: MotivationDiscipline;
    evidenceScope: MotivationEvidenceScope;
    valueKind: MotivationValueKind;
  };
  subject: { label: 'You'; participants: [] };
  value: MotivationFactValue;
  reconciliationNotice: string | null;
}

export interface MotivationFactCollection {
  items: MotivationFact[];
}

export interface MotivationRow {
  code: MotivationFactCode;
  section: 'Record' | 'Patterns' | 'Personal best';
  label: string;
  value: string;
  detail?: string;
}
